export default __webpack_public_path__ + "static/screenshot-target-scores-176b34747017fbe8b630973ca2d361ca.webp";